import React, { useEffect } from 'react';
import { Button } from '../../components/ui';
import { useReportPdf, ReportPdfActions, ReportPdfBody } from '../../components/reports/ReportPdf';

/**
 * Candidate report modal.
 *
 * The WizeTok Interview Report PDF from /api/reports (the document the
 * customer receives), previewed inline with Download / Regenerate.
 *   - one exam:      <ReportModal sessionId onClose />
 *   - combined:      <ReportModal campaignId email name onClose />  (2+ exams, grouped by email)
 */
export default function ReportModal({ sessionId, campaignId, email, name, onClose }) {
  const combined = Boolean(campaignId && email);
  const report = useReportPdf({ sessionId, campaignId, email });

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [onClose]);

  const title = combined ? 'Combined report' : 'Interview report';
  return (
    <div className="wz-report-scrim" role="dialog" aria-modal="true" aria-label={title}>
      <div className="wz-report-box wz-report-pdfbox">
        <div className="wz-report-head">
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <span style={{ fontWeight: 600, fontSize: 15 }}>{title}</span>
            <span className="wz-sub wz-ellipsis" style={{ fontSize: 12 }}>
              {combined ? `${name || email} · all exams in this position` : 'The PDF your customer receives'}
            </span>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
            <ReportPdfActions {...report} />
            <Button iconOnly icon="x" aria-label="Close" onClick={onClose} />
          </div>
        </div>
        <ReportPdfBody pdf={report.pdf} title={title} />
      </div>
    </div>
  );
}
